// Header.styles.ts
import styled from 'styled-components';

export const StyledLinkMenu = styled.a`
    cursor:pointer;
    text-decoration: none;
    color: #000;
`;
